import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Registration from "./pages/Registration";
import DelayedHeader from "./components/DelayedHeader";
import Header from "./components/Header";
import Footer from "./components/Footer";
import NewParty from "./pages/NewParty";
import Rules from "./pages/Rules";
import { AuthContext } from "./helpers/AuthContext";
import { useState, useEffect } from "react";
import axios from "axios";
import ProtectedRoute from "./components/ProtectedRoute";
import LoggedInProtectedRoute from "./components/LoggedInProtectedRoute";
import EmailVerificationSuccess from "./pages/EmailVerificationSuccess";
import VerifyEmail from "./pages/VerifyEmail";
import Friends from "./pages/Friends";
import Game from "./pages/Game";
import GlobalRanking from "./pages/GlobalRanking";

function App() {
  const [authState, setAuthState] = useState({
    username: "",
    id: 0,
    status: false,
  });

  useEffect(() => {
    axios
      .get("https://verbalvortex-server.onrender.com/auth/auth", {
        headers: {
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        if (response.data.error) {
          setAuthState({ ...authState, status: false });
        } else {
          setAuthState({
            username: response.data.username,
            id: response.data.id,
            status: true,
          });
        }
      });
  }, []);

  return (
    <div className="App">
      <AuthContext.Provider value={{ authState, setAuthState }}>
        <Router>
          {!authState.status ? (
            <>
              <DelayedHeader />
            </>
          ) : (
            <Header />
          )}
          <Routes>
            <Route
              path="/"
              element={
                <LoggedInProtectedRoute>
                  <Login />
                </LoggedInProtectedRoute>
              }
            />
            <Route
              path="/registration"
              element={
                <LoggedInProtectedRoute>
                  <Registration />
                </LoggedInProtectedRoute>
              }
            />
            <Route
              path="/emailVerificationSuccess/:token"
              element={<EmailVerificationSuccess />}
            />
            <Route path="/verifyEmail" element={<VerifyEmail />} />
            <Route
              path="/newParty"
              element={
                <ProtectedRoute>
                  <NewParty />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rules"
              element={
                <ProtectedRoute>
                  <Rules />
                </ProtectedRoute>
              }
            />
            <Route
              path="/game/:gameId"
              element={
                <ProtectedRoute>
                  <Game />
                </ProtectedRoute>
              }
            />
            <Route
              path="/friends"
              element={
                <ProtectedRoute>
                  <Friends />
                </ProtectedRoute>
              }
            />
            <Route
              path="/globalRanking"
              element={
                <ProtectedRoute>
                  <GlobalRanking />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
        <Footer />
      </AuthContext.Provider>
    </div>
  );
}

export default App;
